import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function BeachFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M2.25 17C2.25 16.7402 2.38442 16.499 2.60531 16.3623C2.62348 16.3516 2.6833 16.3165 2.71418 16.2996C2.77593 16.2657 2.86298 16.2201 2.97465 16.1668C3.19794 16.0603 3.52001 15.923 3.93531 15.7871C4.76644 15.5154 5.97016 15.25 7.5 15.25C9.70494 15.25 11.5723 15.8203 13.4492 16.3934C13.6009 16.4397 13.753 16.4862 13.905 16.5322C15.949 17.1516 18.1133 17.75 21 17.75C21.4142 17.75 21.75 18.0858 21.75 18.5V21.75H3C2.58579 21.75 2.25 21.4142 2.25 21V17Z"
				fill="currentColor"
			/>
			<path
				d="M13.2356 2.55539C9.68049 1.04779 5.5814 2.71544 4.07895 6.27527C3.86446 6.78347 4.102 7.36939 4.60984 7.58475L9.19624 9.52969L7.28883 13.9518C7.35861 13.9508 7.429 13.9503 7.5 13.9503C8.16482 13.9503 8.80089 13.9978 9.41235 14.0784L11.0376 10.3105L15.6353 12.2603C15.8797 12.3639 16.1553 12.3661 16.4014 12.2664C16.6475 12.1666 16.8437 11.9731 16.947 11.7285C18.4489 8.16986 16.7894 4.06247 13.2356 2.55539Z"
				fill="currentColor"
			/>
		</svg>
	);
}

BeachFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default BeachFilledIcon;
